import { memo } from 'react';
import classNames from 'classnames';

import instagramIcon from 'Assets/images/instagram-icon.svg';
import profilePlaceholder from 'Assets/images/loading-profile.jpg';

import { ErrorPlaceholders, ImageErrorPlaceholderType } from '../constants';

type Props = {
  className?: string;
  forwardedRef?: React.RefObject<any>;
  type: ImageErrorPlaceholderType;
};

const ErrorPlaceholder = (props: Props) => {
  const { className, forwardedRef, type } = props;

  const style: React.CSSProperties = {
    // default
    ...(type === ErrorPlaceholders.AVATAR
      ? {
          backgroundImage: `url(${profilePlaceholder})`,
        }
      : {}),
    ...(type === ErrorPlaceholders.INSTAGRAM
      ? {
          backgroundImage: `url(${instagramIcon})`,
          backgroundSize: '50%',
        }
      : {}),
  };

  return (
    <div
      className={classNames('Bgp(c) Bgr(nr) Bgc($c-ds-background-secondary)', 'Bgz(cv)', className)}
      style={style}
      ref={forwardedRef}
    />
  );
};

export default memo(ErrorPlaceholder);
